import { create } from 'zustand';

interface FormValues {
  email: string;
  // Only used by the native BLIK form; the P24 (blik_checkout) form omits it.
  code?: string;
}

type BlikFormState = {
  isFormValid: boolean;
  formValues: FormValues;
};

type BlikFormStateAction = {
  triggerFormValidation: () => void;
  setFormSubmit: (submitFunction: any) => void;
  setIsFormValid: (isValid: boolean) => void;
  setFormValues: (values: FormValues) => void;
};

export const useBlikForm = create<BlikFormState & BlikFormStateAction>()((set) => ({
  cardObj: null,
  isFormValid: false,
  formValues: { email: '', code: '' },
  triggerFormValidation: () => {},
  setFormSubmit: (submitFunction: any) => set({ triggerFormValidation: submitFunction }),
  setIsFormValid: (isFormValid: boolean) => set({ isFormValid }),
  setFormValues: (values: FormValues) => set({ formValues: values }),
}));
